import {Button, IconButton} from '@dropbox/dig-components/buttons';
import {Text} from '@dropbox/dig-components/typography';
import {Box, Split} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {DeleteLine, EditLine} from '@dropbox/dig-icons/assets';

export const QueuedMessageBanner = ({
  message,
  onDelete,
  onEdit,
  onSendNow,
}: {
  message: string;
  onDelete: () => void;
  onEdit: () => void;
  onSendNow: () => void;
}) => (
  <Box backgroundColor="Background Subtle" borderRadius="Medium" padding="12" marginBottom="8">
    <Text size="small" isBold>
      1 Queued Message
    </Text>
    <Box paddingTop="8">
      <Split alignY="center" gap="8">
        <Split.Item width="fill">
          <Split alignY="center" gap="8">
            <Split.Item>
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: 'var(--dig-color__primary__base)',
                  display: 'inline-block',
                  flexShrink: 0,
                }}
              />
            </Split.Item>
            <Split.Item width="fill">
              <Box style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                <Text size="small">{message}</Text>
              </Box>
            </Split.Item>
          </Split>
        </Split.Item>
        <Split.Item width="hug">
          <Split alignY="center" gap="4">
            <Split.Item>
              <IconButton
                variant="borderless"
                size="small"
                onClick={onDelete}
                aria-label="Delete queued message"
              >
                <UIIcon src={DeleteLine} />
              </IconButton>
            </Split.Item>
            <Split.Item>
              <IconButton
                variant="borderless"
                size="small"
                onClick={onEdit}
                aria-label="Edit queued message"
              >
                <UIIcon src={EditLine} />
              </IconButton>
            </Split.Item>
            <Split.Item>
              <Button variant="outline" size="small" onClick={onSendNow}>
                Send Now
              </Button>
            </Split.Item>
          </Split>
        </Split.Item>
      </Split>
    </Box>
  </Box>
);
